@if (redirectNotice.visible()) {
<div class="redirect-notice-backdrop" aria-live="polite" aria-modal="true" role="dialog">
    <div class="redirect-notice-card">
        <p class="fs-5 fw-light mb-2">Du skickas vidare</p>
        <p class="redirect-notice-message">{{ redirectNotice.message() }}</p>
        @if (redirectNotice.countdownSeconds() !== null) {
        <p class="redirect-notice-countdown">Omdirigering om {{ redirectNotice.countdownSeconds() }} sek.</p>
        }
    </div>
</div>
}
